const config = require('appConfig');

export const baseUrl = config.api.baseUrl;

// for Java API
export const googleLogin = baseUrl + '/google/login';

export const logout = '/logout';

export const getLogs = '/logs';

export const getProfile = '/getProfile';

export const admins = '/admins';

export const checkRoles = '/checkRoles';

export const roles = '/roles';

export const getServiceRegion = '/getServiceRegion';

export const getRoleGroupDetail = '/getRoleGroupDetail';

export const getRoleDetail = '/getRoleDetail';

export const updateRoleGroup = '/updateRoleGroup';

export const updateRole = '/updateRole';

export const getSubscriptionStatus = '/subscriptionStatus';

export const updatePreSubscription = '/updatePreSubscription';
export const deletePreSubscription = '/deletePreSubscription';
export const preSubscriptions = '/preSubscriptions';
export const uploadPreSubscription = '/uploadPreSubscription';
export const downloadExcelTemplate = baseUrl + '/downloadExcelTemplate';

export const getSubscriptionProductTypes = '/subscriptionProductTypes';

export const createProduct = '/createProduct';

export const updateProduct = '/updateProduct';

export const getSubscriptionProduct = '/subscriptionProduct';

export const getPatientName= '/getPatientName';

export const getPatientsList = '/getPatientsList';

export const getPatientDetail = '/getPatientDetail';

export const getPaymentDetail = '/getPaymentDetail';

export const getUserList = '/getUserList';

export const updatePatientInfo = '/updatePatientInfo';

export const resetPassword = '/resetPassword';

export const updatePatientSubscription = '/updatePatientSubscription';

export const createFreePatientSubscription = '/createFreePatientSubscription';

export const updateInstallmentAmount = '/updateInstallmentAmount';

export const savePayment = '/savePayment';

export const deletePayment = '/deletePayment';


export const updateInstallmentPeriod = '/updateInstallmentPeriod';

export const getClinicianList = '/getClinicianList';

export const getPatientListForMapping = '/getPatientListForMapping';

export const getPatientClinicianMapping = '/getPatientClinicianMapping';

export const getClinicianPatientMapping = '/getClinicianPatientMapping';

export const mapClinicianToPatients = '/mapClinicianToPatients';

export const mapPatientToClinicians = '/mapPatientToClinicians';


export const getServiceName = '/getServiceName';

export const createAssetVersion = '/createAssetVersion';

export const getAssetVersions = '/getAssetVersions';

export const getAssetFileList = '/getAssetFileList';

export const deleteAsset = '/deleteAsset';

export const uploadAsset = baseUrl + '/uploadAsset';

export const uploadAssetJson = '/uploadAssetJson';

export const copyAssets = '/copyAssets';

export const getAdmin = '/getAdmin';

export const getRoleGroups = '/roleGroups';

export const updateAdminUser = '/updateAdminUser';

export const createContract = '/createContract';

export const updateContractProduct = '/updateContractProduct';

export const contractList = '/contractList';

export const updateSerialNo = '/updateSerialNo';

export const updateBillingDate = '/updateBillingDate';

export const updateOpportunityLink = '/updateOpportunityLink';

export const charge = '/charge';


export const updatEexpectedPaymentMonth = '/updatEexpectedPaymentMonth';

export const cancelContract = '/cancelContract';

export const activateContract = '/activateContract';

export const paymentHistory = '/paymentHistory';

export const downloadPaymentHistory = '/downloadPaymentHistory';

export const refund = '/refund';


export const checkEmail = '/checkEmail';

export const messageCodes = '/messageCodes';

export const messageCode = '/messageCode';

export const deleteMessageCode= '/deleteMessageCode';

export const messageTexts = '/messageTexts';

export const updateMessage = '/updateMessage';

export const downloadMessage = baseUrl + '/downloadMessage';
export const downloadBulkTemplate = baseUrl + '/downloadBulkTemplate';
export const downloadSearchTemplate = baseUrl + '/downloadBulkTemplateWithSearchResult';

export const uploadMessage = '/uploadMessage';
export const uploadBulkMessage = '/uploadBulkMessage';

export const rapaelClients = '/rapaelClients';

export const rapaelClient = '/rapaelClient';

export const updateRapaelClient = '/updateRapaelClient';

export const deleteRapaelClient = '/deleteRapaelClient';

export const inactivateRapaelClient = '/inactivateRapaelClient';

export const activateRapaelClient = '/activateRapaelClient';

export const downloadRapaelClient = baseUrl + '/downloadRapaelClient';

export const uploadRapaelClient = '/uploadRapaelClient';

export const contentMetas = '/contentMetas';

export const contentMeta = '/contentMeta';

export const updateContentMeta = '/updateContentMeta';

export const deleteContentMeta = '/deleteContentMeta';

export const inactivateContentMeta = '/inactivateContentMeta';

export const activateContentMeta = '/activateContentMeta';

export const contentClients = '/contentClients';

export const contentClient = '/contentClient';

export const updateContentClient = '/updateContentClient';

export const deleteContentClient = '/deleteContentClient';

export const inactivateContentClient = '/inactivateContentClient';

export const activateContentClient = '/activateContentClient';

export const updateCreditCard = '/updateCreditCard';



// WEBPACK FOOTER //
// ./src/api/url.js